import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { capitalize } from 'lodash';

import { useStores } from '@/hooks/use-stores';
import EPTable from '@/comp/EPTable';
import TableHeaderCell from '@/comp/pages/EnginePage/Engine/Common/TableHeaderCell/TableHeaderCell';

import { ResultContainer } from './styled';

const Result = () => {
  const { t } = useTranslation();
  const { engineStore } = useStores();

  const sensorsPriorityColumns = [
    {
      dataIndex: 'priority',
      key: 'priority',
      title: ' ',
      width: '15%',
      render: priority => <TableHeaderCell titleKey={priority === 0 ? t('main') : t('fallback', { priority })} />,
    },
    {
      dataIndex: 'aggregation',
      key: 'aggregation',
      title: <TableHeaderCell titleKey="logic" />,
      width: '15%',
      render: aggregation => <span className="table-cell">{capitalize(aggregation)}</span>,
    },
    {
      dataIndex: 'availability',
      key: 'availability',
      title: <TableHeaderCell titleKey="online" />,
      width: '15%',
      render: availability => <span className="table-cell">{t(availability)}</span>,
    },
    {
      dataIndex: 'sensors',
      key: 'sensors',
      title: <TableHeaderCell titleKey="sensors" />,
      width: '55%',
      render: sensors => (
        <div className="table-cell">
          {sensors?.map(sensor => (
            <div className="chip-item" key={sensor?.name}>
              {sensor?.name}
            </div>
          ))}
        </div>
      ),
    },
  ];

  return (
    <ResultContainer $hasFinishedWizard={engineStore.hasFinishedWizard}>
      <span className="header">{t('flowSensorsSelection')}</span>
      <EPTable
        columns={sensorsPriorityColumns}
        dataSource={engineStore.sensorsConfiguration?.flowSensorsPriority?.sensorsPriority}
        pagination={false}
        className={cn('table', 'sensors-priority-table')}
        sticky={false}
      />
      <span className="header">{t('pressureSensorsSelection')}</span>
      <EPTable
        columns={sensorsPriorityColumns}
        dataSource={engineStore.sensorsConfiguration?.pressureSensorsPriority?.sensorsPriority}
        pagination={false}
        className={cn('table', 'sensors-priority-table')}
      />
    </ResultContainer>
  );
};

export default Result;
